import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Component, createRef } from '@wordpress/element';
import { isEqual, throttle } from 'lodash';
import { select as d3Select } from 'd3-selection';
/**
 * Provides foundation to use D3 within React.
 *
 * React is responsible for determining when a chart should be updated (e.g. whenever data changes or the browser is
 * resized), while D3 is responsible for the actual rendering of the chart (which is performed via DOM operations that
 * happen outside of React's control).
 *
 * This component makes use of new lifecycle methods that come with React 16.3. Thus, while this component (i.e. the
 * container of the chart) is rendered during the 'render phase' the chart itself is only rendered during the 'commit
 * phase' (i.e. in 'componentDidMount' and 'componentDidUpdate' methods).
 */

var D3Base =
/*#__PURE__*/
function (_Component) {
  _inherits(D3Base, _Component);

  function D3Base(props) {
    var _this;

    _classCallCheck(this, D3Base);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(D3Base).call(this, props));
    _this.chartRef = createRef();
    return _this;
  }

  _createClass(D3Base, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.drawUpdatedChart();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.className !== nextProps.className || !isEqual(this.props.data, nextProps.data) || !isEqual(this.props.orderedKeys, nextProps.orderedKeys) || this.props.drawChart !== nextProps.drawChart || this.props.height !== nextProps.height || this.props.chartType !== nextProps.chartType || this.props.width !== nextProps.width;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.drawUpdatedChart();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.deleteChart();
    }
  }, {
    key: "delayedScroll",
    value: function delayedScroll() {
      var tooltip = this.props.tooltip;
      return throttle(function () {
        tooltip && tooltip.hide();
      }, 300);
    }
  }, {
    key: "deleteChart",
    value: function deleteChart() {
      d3Select(this.chartRef.current).selectAll('svg').remove();
    }
    /**
     * Renders the chart, or triggers a rendering by updating the list of params.
     */

  }, {
    key: "drawUpdatedChart",
    value: function drawUpdatedChart() {
      var drawChart = this.props.drawChart;
      var svg = this.getContainer();
      drawChart(svg);
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      var _this$props = this.props,
          className = _this$props.className,
          height = _this$props.height,
          width = _this$props.width;
      this.deleteChart();
      var svg = d3Select(this.chartRef.current).append('svg').attr('viewBox', "0 0 ".concat(width, " ").concat(height)).attr('height', height).attr('width', width).attr('preserveAspectRatio', 'xMidYMid meet');

      if (className) {
        svg.attr('class', "".concat(className, "__viewbox"));
      }

      return svg.append('g');
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      return createElement("div", {
        className: classNames('d3-base', className),
        ref: this.chartRef,
        onScroll: this.delayedScroll()
      });
    }
  }]);

  return D3Base;
}(Component);

export { D3Base as default };
D3Base.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array,
  orderedKeys: PropTypes.array,
  // required to detect changes in data
  tooltip: PropTypes.object,
  chartType: PropTypes.string
};
//# sourceMappingURL=index.js.map